import { graphql, useStaticQuery } from 'gatsby';
import React, { FunctionComponent } from 'react';
import { useScreenSize } from '../../../hooks/useScreenSize';
import { ArticlePreview } from '../../../types/articlePreview';
import { Background } from '../../../types/background';
import { PagePath, SanityArticleTag, SanityImage, SanityTeaser } from '../../../types/common';
import SwitchContent from '../../SwitchContent';
import ArticlePageTeaser from './ArticlePageTeaser';
import './styles.scss';

export type DoubleFeaturedArticlesPage = {
  title: string;
  image?: SanityImage | null;
  teaser?: SanityTeaser | null;
  tags?: SanityArticleTag[] | null;
  categories?: {
    _id: string;
  }[] | null;
} & PagePath;

type DoubleFeaturedArticlesProps = {
  data: {
    background: Background;
    firstPage: DoubleFeaturedArticlesPage;
    secondPage: DoubleFeaturedArticlesPage;
    htmlId: string | null;
  };
}

function filterArticles(articles: ArticlePreview[], categories: { _id: string }[] | null | undefined) {
  if (!categories) {
    return [];
  }

  return articles.filter(article => article.categories?.some(item => categories.some(category => category._id === item._id))).slice(0, 4);
}

const DoubleFeaturedArticles: FunctionComponent<DoubleFeaturedArticlesProps> = ({ data }) => {
  const pages = [data.firstPage, data.secondPage];
  const { isMobile } = useScreenSize();

  const queryResponse = useStaticQuery(graphql`
    query TeaserArticles {
      allSanityArticles(sort: {_createdAt: DESC}) {
        ...ArticlesPreviewList
      }
    }
  `);
  const allArticles = queryResponse.allSanityArticles.nodes as ArticlePreview[];
  const pagesArticles = pages.map((page) => filterArticles(allArticles, page.categories));

  return (
    <section className={`double-featured-articles ${data.background}`} id={data.htmlId || undefined}>
      <div>
        {isMobile && (
          <SwitchContent
            firstLabel={pages[0].teaser?.title || pages[0].title}
            firstContent={<ArticlePageTeaser page={pages[0]} articles={pagesArticles[0]} />}
            secondLabel={pages[1].teaser?.title || pages[1].title}
            secondContent={<ArticlePageTeaser page={pages[1]} articles={pagesArticles[1]} />}
          />
        )}

        {!isMobile && pages.map((page, index) => (
          <ArticlePageTeaser
            key={page._id}
            page={page}
            articles={pagesArticles[index]}
          />
        ))}
      </div>
    </section>
  );
}

export default DoubleFeaturedArticles;
